import * as tslib_1 from "tslib";
import { TemplateRef, ComponentRef, EmbeddedViewRef } from '@angular/core';
import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { TemplatePortal, ComponentPortal } from '@angular/cdk/portal';
import { ApDialogContainer } from '../components/dialog-container/dialog-container.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { arrayFlatMap } from '@awp/core/utils';
import { Location } from '@angular/common';
import { ApDialogRef } from './ap-dialog-ref';
var _defaultOptions = {
    backdropClass: 'no-backdrop',
    hasBackdrop: true,
    panelClass: ['mat-dialog-container'] // NOTE: This comes from global styles..
};
var ApDialogService = /** @class */ (function () {
    function ApDialogService(_overlay, _breakpointObserver, _location) {
        this._overlay = _overlay;
        this._breakpointObserver = _breakpointObserver;
        this._location = _location;
    }
    ApDialogService.prototype.open = function (componentOrTemplateRef, configBuilder) {
        var builder = new OverlayConfigBuilder(this._overlay, _defaultOptions, this._breakpointObserver);
        if (configBuilder) {
            configBuilder(builder);
        }
        var overlayConfig = new OverlayConfig(builder.getConfig());
        var overlayRef = this._overlay.create(overlayConfig);
        var dialogRef;
        var onCloseData = {};
        var containerPortal = new ComponentPortal(ApDialogContainer);
        var containerPortalRef = overlayRef.attach(containerPortal);
        if (componentOrTemplateRef instanceof TemplateRef) {
            var portal = new TemplatePortal(componentOrTemplateRef, null);
            onCloseData.template = containerPortalRef.instance.attachTemplatePortal(portal);
        }
        else {
            var portal = new ComponentPortal(componentOrTemplateRef, null);
            onCloseData.component = containerPortalRef.instance.attachComponentPortal(portal);
        }
        dialogRef = new ApDialogRef(onCloseData, overlayRef);
        containerPortalRef.instance.setDialogRef(dialogRef);
        overlayRef.backdropClick().subscribe(function () {
            dialogRef.close();
        });
        // Subscribe to navigation changes - close dialog on navigation.
        var navigationSubscription = this._location.subscribe(function () { return dialogRef.close(); });
        overlayRef.detachments().subscribe(function () {
            // Unsubscribe from subscriptions (avoid Memory Leaks here)
            navigationSubscription.unsubscribe();
        });
        return dialogRef;
    };
    return ApDialogService;
}());
export { ApDialogService };
/** Helper class to configure an OverlayConfig */
var OverlayConfigBuilder = /** @class */ (function () {
    function OverlayConfigBuilder(_overlay, config, breakPointObserver) {
        this._overlay = _overlay;
        this.breakPointObserver = breakPointObserver;
        this._config = tslib_1.__assign({}, config);
    }
    /** Makes the dialog fill the screen on a Handset */
    OverlayConfigBuilder.prototype.fullScreenOnHandset = function () {
        if (this.breakPointObserver.isMatched(Breakpoints.Handset)) {
            this._config.width = "100vw";
            this._config.height = "100vh";
            this._config.positionStrategy = this._overlay.position().global().top("0px").left("0px");
            this._config.scrollStrategy = this._overlay.scrollStrategies.block();
        }
        return this;
    };
    /** Makes the overlay bahave like a dropdown over an anchor element */
    OverlayConfigBuilder.prototype.dropDownOverAnchor = function (options) {
        return this.dropWithflexiblePositions([{
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'top'
            }, {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'bottom'
            }], options);
    };
    /** Makes the overlay bahave like a dropdown under an anchor element */
    OverlayConfigBuilder.prototype.dropDownUnderAnchor = function (options) {
        return this.dropWithflexiblePositions([{
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top'
            }, {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom'
            }], options);
    };
    OverlayConfigBuilder.prototype.dropWithflexiblePositions = function (positions, options) {
        var positionStrategy = this._overlay.position()
            .flexibleConnectedTo(options.anchor)
            .withPositions(positions);
        if (options.offset != null) {
            if (options.offset.y != null) {
                positionStrategy.withDefaultOffsetY(options.offset.y);
            }
            if (options.offset.x != null) {
                positionStrategy.withDefaultOffsetX(options.offset.x);
            }
        }
        this._config.positionStrategy = positionStrategy;
        this._config.scrollStrategy = this._overlay.scrollStrategies.reposition();
        if (options.panelClass != null) {
            this._config.panelClass = arrayFlatMap([this._config.panelClass, options.panelClass]);
        }
        if (options.sameWidthAsAnchor) {
            var rect = options.anchor.getBoundingClientRect();
            this._config.width = rect.width + "px";
        }
        if (options.width) {
            this._config.width = options.width;
        }
        this._config.height = "auto";
        return this;
    };
    /** Sets properties on the OverlayConfig */
    OverlayConfigBuilder.prototype.properties = function (config) {
        this._config = tslib_1.__assign({}, this._config, config);
        return this;
    };
    OverlayConfigBuilder.prototype.getConfig = function () {
        return this._config;
    };
    return OverlayConfigBuilder;
}());
export { OverlayConfigBuilder };
